import debounce from '../../debounce';
import errorManager from '@/rollbar.js';

const togglesVersionInput = (input, initialValue) => {
  let inputVersions,
    allInputInSection,
    allInputSectionHash = {};
  if (input.closest('.well').find('.section_guest_valutation_update').length) {
    inputVersions = input.closest('.well').find('.section_guest_valutation_update');
    allInputInSection = input.closest('.well').find('input, select, textarea');
  } else {
    inputVersions = input.closest('.tab-pane').find('.section_guest_valutation_update');
    allInputInSection = input.closest('.tab-pane').find('input, select, textarea');
  }
  allInputInSection.each((field, val) => {
    allInputSectionHash[val.name] = allInputSectionHash[val.name] || [];
    allInputSectionHash[val.name].push(JSON.stringify({ name: val.name, value: val.value }));
  });
  Object.keys(allInputSectionHash).every((inputName) => {
    if (
      initialValue &&
      initialValue[inputName] &&
      JSON.parse(initialValue[inputName][0])['value'] != JSON.parse(allInputSectionHash[inputName][0])['value']
    ) {
      inputVersions.prop('disabled', false);
      return false;
    }
    inputVersions.prop('disabled', true);
    return true;
  });
};

const getInitialValue = (form) => {
  return form.serializeArray().reduce((acc, field) => {
    acc[field.name] = acc[field.name] || [];
    acc[field.name].push(JSON.stringify(field));
    return acc;
  }, {});
};

const setInitialValue = () => {
  try {
    //guest_valutation[scheda_medico_specialistica][proveniente_da][value];
    window.versioningSection.initialValue = { ...getInitialValue($('.js-versioning-section')) };
  } catch (e) {
    console.error(e);
  }
};

const getInitial = () => {
  return window.versioningSection.initialValue ?? setInitialValue();
};

const resetFormStatus = () => {
  const hasRemoteSave = $('.js-versioning-section').attr('remote-submit-changed');
  if (hasRemoteSave == 'true') {
    $(document).on('form-saved', '.js-versioning-section', () => {
      Loader.show();
      setInitialValue();
      $('.js-versioning-section .section_guest_valutation_update').attr('disabled', 'disabled');
      Loader.hide();
    });
  }
};

const setObserver = () => {
  eventBus.$on('reloadOriginalState', () => {
    setInitialValue();
  });
  eventBus.$on('init-vtextarea', (data) => {
    const input = $(`#${data.id}`);
    const isInVersioningArea = input.closest('.js-versioning-section').length;
    if (isInVersioningArea) {
      data.editor.on(
        'keyup paste change',
        debounce((e) => {
          togglesVersionInput(input, getInitial());
        }, 400),
      );
    }
  });
  eventBus.$on('init-rich-text-editor', (data) => {
    const input = $(`#${data.id}`);
    const isInVersioningArea = input.closest('.js-versioning-section').length;
    if (isInVersioningArea) {
      data.element.on(
        'valuechanged',
        debounce((e) => {
          togglesVersionInput(input, getInitial());
        }, 400),
      );
    }
  });
  $(document).on(
    'change changed paste',
    '.js-versioning-section input, .js-versioning-section select, .js-versioning-section textarea, .js-versioning-section .js-rich-text-editor',
    (ev) => {
      const input = $(ev.target);
      togglesVersionInput(input, getInitial());
    },
  );
  resetFormStatus();
};

const hideLastRevisor = (fieldName) => {
  let cv;

  if ($(fieldName).closest('.well').find('.section_last_revised_cv').length) {
    cv = $(fieldName).closest('.well').find('.section_last_revised_cv')[0];
  } else if ($(fieldName).closest('.tab-pane').find('.section_last_revised_cv').length) {
    cv = $(fieldName).closest('.tab-pane').find('.section_last_revised_cv')[0];
  }
  cv ? $(cv).hide() : null;
};

const showCurrentRevisor = (fieldName) => {
  let el;
  let today = new Date();

  if ($(fieldName).closest('.well').find('.section_last_revised').length) {
    el = $(fieldName).closest('.well').find('.section_last_revised')[0];
  } else {
    el = $(fieldName).closest('.tab-pane').find('.section_last_revised')[0];
  }

  el
    ? $(el)
        .find('.media-body span.media-body-time')
        .html(`${today.getHours()}:${String(today.getMinutes()).padStart(2, '0')}`)
    : null;
  el ? $(el).find('.media-body span.media-body-date').html(`${today.toLocaleDateString()}`) : null;
  el ? $(el).show() : null;
};

const updateCurrentRevisor = (item, index, arr) => {
  let fieldName = `[name="${item.name}"]`;
  hideLastRevisor(fieldName);
  showCurrentRevisor(fieldName);
};

const updateVersionDuringSave = (fieldName) => {
  const field = $(`*[name="${fieldName}"`);
  const inputPane = field.closest('.tab-pane').find('.section_guest_valutation_update');
  const inputWell = field.closest('.well').find('.section_guest_valutation_update');
  const inputSection = inputPane.length ? inputPane : inputWell;
  let results = [];

  if (!inputSection.length || field.hasClass('section_guest_valutation_update')) {
    return results;
  }

  inputSection.each((index, el) => {
    if (el.disabled) {
      $(el).prop('disabled', false);
      results.push({ name: $(el).attr('name'), value: $(el).val() });
    }
  });

  return results;
};

const addVersions = (fieldsChanged) => {
  try {
    let changes = fieldsChanged.map((el) => updateVersionDuringSave(el.name)).flat();
    return [...fieldsChanged, ...changes];
  } catch (e) {
    errorManager(e);
  }
};

const updateSelect2 = (fieldsChanged) => {
  const select2Elements = fieldsChanged.reduce((acc, obj) => {
    if (obj.name.endsWith('[]') && obj.value !== '') {
      if (!acc[obj.name]) {
        acc[obj.name] = [];
      }
      acc[obj.name].push(obj.value);
    }
    return acc;
  }, {});

  for (const [key, value] of Object.entries(select2Elements)) {
    $(`select[name="${key}"]`).val(value).trigger('change');
  }
};

const initListener = () => {
  try {
    setObserver();
  } catch (e) {
    console.error(e);
  }

  eventBus.$on('fields_changed', (fieldsChanged) => {
    fieldsChanged?.forEach(updateCurrentRevisor);
    fieldsChanged.some((field) => field.name.endsWith('[]')) &&
      setTimeout(() => {
        updateSelect2(fieldsChanged);
      }, 200);
  });
};

const init = () => {
  try {
    initListener();
  } catch (e) {
    errorManager(e);
  }
};

window.versioningSection = {
  init,
  initialValue: null,
  setInitialValue: setInitialValue,
  changedValues: addVersions,
};
